export default __webpack_public_path__ + "static/media/dark_1_placeholder.2f179090.jpg";